// extracted by mini-css-extract-plugin
export default {"menu":"RegularHeader_menu__E2Z0i","menu__logo":"RegularHeader_menu__logo__p96Bl","nav":"RegularHeader_nav__435-I","nav-list":"RegularHeader_nav-list__t20xg"};